<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { computed, toRefs } from 'vue';

import type { MessageState } from '#nora-chat-ui/states';
import { useConversationStore } from '#nora-chat-ui/stores/conversation/conversation-store';

interface ViewMessageProps {
  messageState: MessageState;
}

const props = defineProps<ViewMessageProps>();

const emit = defineEmits(['showSeenByModal']);
const { messageState } = toRefs(props);
const conversationStore = useConversationStore();

const { isGroupConversation, getLastReadMessage }
  = storeToRefs(conversationStore);

const seenByCount = computed(() => {
  return messageState.value.message.readMessagesCount ?? 0;
});

const showSeenByCounter = computed(
  () =>
    !messageState.value.message.deletedAt
    && isGroupConversation.value(messageState.value.message.conversationId)
    && seenByCount.value > 0,
);

const showSeenBy = computed(
  () =>
    showSeenByCounter.value
    || (!isGroupConversation.value(messageState.value.message.conversationId)
      && getLastReadMessage.value(messageState.value.message.conversationId)
        ?.message
        .id === messageState.value.message.id),
);

function handleClickSeenBy() {
  emit('showSeenByModal');
}
</script>

<template>
  <span class="cursor-pointer flex" @click="() => handleClickSeenBy()">
    <span v-if="showSeenBy" class="mi md-16 mr-1 visibility" /><span
      v-if="showSeenByCounter"
      class="leading-none h-auto my-auto"
    >{{ ` ${seenByCount}` }}</span>
  </span>
</template>
